import { Masks } from "@hooks/functions/Masks/Masks";
import { RaffleDefaultWord } from "@components/raffles/default/word";
import { RaffleDefaultWordHowItWorks } from "./how-it-works";

export function RaffleDefaultWordPreview() {
  const masks = new Masks();

  return (
    <>
      {/* How it Works */}
      <div className="row">
        <div className="col-md-12">
          <RaffleDefaultWordHowItWorks />
        </div>
      </div>

      {/* Raffle Default Number Component */}
      <div className="row">
        <div className="col-md-12">
          <RaffleDefaultWord />
        </div>
      </div>
    </>
  );
}
